document.addEventListener("teeinblue-event-component-injected", function () {
  var selectBoxes = document.querySelectorAll(".tee-field__select");

  selectBoxes.forEach(function (selectBox) {
    var options = selectBox.options;

    for (var i = 0; i < options.length; i++) {
      var text = options[i].textContent;
      if (text.includes("&euro;")) {
        options[i].textContent = text.replace(/&euro;/g, "€");
      }
    }
  });
});

document.addEventListener("teeinblue-event-component-injected", function () {
  const elementToMove = document.querySelector(
    ".product__info-wrapper.grid__item accordion-tab.product__accordion.accordion"
  );
  const insertAfterElement = document.querySelector(
    ".tee-product-price-hook--after"
  );
  if (elementToMove && insertAfterElement) {
    insertAfterElement.after(elementToMove);
  }

  if (!elementToMove) {
    const elementToMove2 = document.querySelector(".product__description");
    const insertAfterElement2 = document.querySelector(
      ".tee-product-price-hook--after"
    );
    if (elementToMove2 && insertAfterElement2) {
      insertAfterElement2.after(elementToMove2);
    }
  }
});

document.addEventListener("teeinblue-event-after-cart-added", () => {
  const drawer = document.querySelector("mini-cart");
  if (drawer) {
    fetch(window.location.pathname + "/?sections=mini-cart,cart-icon-bubble")
      .then((res) => res.json())
      .then((res) => drawer.renderContents({ sections: res }));
    if (drawer.classList.contains("is-empty"))
      drawer.classList.remove("is-empty");
  }
});
console.log("heno");

document.addEventListener("teeinblue-event-component-injected", function () {
  let toggleBtn = document.querySelector(".tee-btn.tee-btn--personalize");
  let targetBtn = document.querySelector(
    ".teeinblue-enabled .product-form__submit"
  );

  if (toggleBtn && targetBtn) {
    toggleBtn.addEventListener("click", function () {
      console.log("heno");
      if (
        targetBtn.style.display === "none" ||
        targetBtn.style.display === ""
      ) {
        targetBtn.style.display = "block"; // Hiển thị lại nút
      } else {
        targetBtn.style.display = "none"; // Ẩn nút
      }
    });
  }
});


document.addEventListener('teeinblue-event-component-injected', function() {
  const elementToMove = document.querySelector('.product__description.rte');
  const insertAfterElement = document.querySelector('.tee-block.tee-product-price');
  if (elementToMove && insertAfterElement) {        
    insertAfterElement.after(elementToMove);
    elementToMove.style.marginTop = '-10px';
  } 
});
